import { StyledPropType } from 'style-utils/core/core.types';
import { createExtractCssFromProps } from 'style-utils/core/createExtractCssFromProps/createExtractCssFromProps';
import { CSSProperties } from 'styled-components';

const positionMappedProperties = {
  position: true,
  zIndex: true,
  top: true,
  right: true,
  bottom: true,
  left: true,
  inset: true,
};

export type WithPositionProps = {
  position?: StyledPropType<CSSProperties['position']>;
  zIndex?: StyledPropType<CSSProperties['zIndex']>;
  top?: StyledPropType<CSSProperties['top']>;
  right?: StyledPropType<CSSProperties['right']>;
  bottom?: StyledPropType<CSSProperties['bottom']>;
  left?: StyledPropType<CSSProperties['left']>;
  inset?: StyledPropType<CSSProperties['inset']>;
};

export const withPosition = createExtractCssFromProps(positionMappedProperties);
